import { Dictionary } from "lodash";

export enum CardCustomField {
  Text = "text",
  Number = "number",
  Date = "date",
  Money = "money",
  Url = "url",
  Email = "email",
}

export const CustomFieldLabels: Dictionary<string> = {
  [`${CardCustomField.Text}`]: "app.opportunity.customField.text",
  [`${CardCustomField.Number}`]: "app.opportunity.customField.number",
  [`${CardCustomField.Date}`]: "app.opportunity.customField.date",
  [`${CardCustomField.Money}`]: "app.opportunity.customField.money",
  [`${CardCustomField.Url}`]: "app.opportunity.customField.url",
  [`${CardCustomField.Email}`]: "app.opportunity.customField.email",
};

export const CustomFieldOptions = [
  { value: CardCustomField.Text, label: "app.opportunity.customField.text" },
  { value: CardCustomField.Number, label: "app.opportunity.customField.number" },
  { value: CardCustomField.Date, label: "app.opportunity.customField.date" },
  { value: CardCustomField.Money, label: "app.opportunity.customField.money" },
  { value: CardCustomField.Url, label: "app.opportunity.customField.url" },
  { value: CardCustomField.Email, label: "app.opportunity.customField.email" },
];

export interface CustomFieldTemplate {
  type: CardCustomField;
  nameKey: string;
  icon: "globe" | "envelope";
}

export const CustomFieldTemplates: CustomFieldTemplate[] = [
  {
    type: CardCustomField.Url,
    nameKey: "app.crmCustomField.template.website",
    icon: "globe",
  },
  {
    type: CardCustomField.Email,
    nameKey: "app.crmCustomField.template.email",
    icon: "envelope",
  },
];